import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, withModifiers as _withModifiers, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-48643895"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mxa-nologin-main" }
const _hoisted_2 = { class: "mxa-nologin-main-explanation" }
const _hoisted_3 = { "data-test": "area_desc_msg1" }
const _hoisted_4 = { "data-test": "area_desc_msg2" }
const _hoisted_5 = { class: "mxa-nologin-main-inputgroup" }
const _hoisted_6 = { class: "mxa-nologin-main-input" }
const _hoisted_7 = { class: "mxa-nologin-main-input-margin" }
const _hoisted_8 = { class: "d-flex justify-content-end" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_10 = {
  type: "button",
  class: "btn mxa-nologin-main-reset",
  "data-test": "reset_link",
  "data-bs-toggle": "modal",
  "data-bs-target": "#confirmModal"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-arrow-right" }, null, -1))
const _hoisted_12 = {
  class: "modal fade",
  id: "confirmModal",
  tabindex: "-1",
  "aria-labelledby": "confirmModalLabel",
  "aria-hidden": "true"
}
const _hoisted_13 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_14 = { class: "modal-content" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    id: "closeOnetime",
    class: "btn-close",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  })
], -1))
const _hoisted_16 = {
  class: "modal-body",
  "data-test": "dialog_msg"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_18 = { class: "modal-body" }
const _hoisted_19 = { class: "container-fluid mb-2 p-0" }
const _hoisted_20 = { class: "row justify-content-center p-0" }
const _hoisted_21 = { class: "mxa-nologin-main-button-double" }
const _hoisted_22 = { class: "mxa-nologin-main-button-double" }

import { computed, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from '@/store'
import BasePassword from '@/components/common/input/BasePassword.vue'
import BaseButton from '@/components/common/button/BaseButton.vue'
import BaseCheckbox from '@/components/common/input/BaseCheckbox.vue'
import ErrorMessage from '@/components/common/screen/ErrorMessage.vue'
import NormalMessage from '@/components/common/screen/NormalMessage.vue'
import * as log from '@/model/util/log/Logger'
import {
  initDom,
  stateUserEntryAuth,
  userEntryAuth,
  userEntryAuthSend,
  useErrorMsg,
  useNormalMsg,
  clearNormalMsg,
} from '@/model/components/users/userEntryAuth'
import { buttonClick } from '@/model/util/dom/domUtil'
import NologinTitle from '@/components/main/nologin/NologinTitle.vue'
import RegisterStepbar from '../../components/main/nologin/RegisterStepbar.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'EntryAuth',
  props: {
  // ユーザー名
  username: {
    type: String,
    default: undefined,
  },
  // 登録種別
  type: {
    type: String,
    default: undefined,
  },
  // リダイレクト
  redirect: {
    type: String,
    default: undefined,
  },
  // ダウンロードキー
  downloadKey: {
    type: String,
    default: undefined,
  },
},
  setup(__props) {

const props = __props

log.trace('EntryAuth setup start.')

// プロパティ定義


// 状態
const state = stateUserEntryAuth(props)
const store = useStore()
const router = useRouter()
const errorState = useErrorMsg()
const nomralState = useNormalMsg()

log.debug(`EntryAuth props: ${JSON.stringify(props)}, state: ${JSON.stringify(state)}`)
// onMountedの登録
onMounted(async () => {
  log.trace('EntryAuth onMounted start.')
  // F5等でusernameが設定されていない場合はTOP画面に遷移
  await initDom(state, store, router)
  log.trace('EntryAuth onMounted end.')
})
/**
 * 次へボタンクリック
 */
const onclick = async () => {
  log.trace('EntryAuth onclick start.')
  // api送信の実施
  await userEntryAuth(state, store, router, errorState, nomralState)
  log.trace('EntryAuth onclick end.')
}
/**
 * ワンタイムパスワード再発行のボタンクリック
 */
const reissue = async () => {
  log.trace('EntryAuth reissue start.')
  // 正常メッセージクリア、エラーメッセージはそのまま
  clearNormalMsg(nomralState)
  // api送信の実施
  await userEntryAuthSend(state, store, errorState, nomralState)
  // ボタンをクリックする事によりメニューを閉じる
  buttonClick('closeOnetime')
  log.trace('EntryAuth reissue end.')
}

/**
 * 認証ボタンのloading有無を返す
 */
const isLoading = computed(() => state.loading)
/**
 * 認証ボタンのdisabled有無を返す
 */
const isDisabled = computed(() => state.loading || state.loadingReissue)

log.trace('EntryAuth setup end.')

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(RegisterStepbar, {
      active: 3,
      type: props.type
    }, null, 8, ["type"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("form", {
        action: "",
        onSubmit: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["prevent"])),
        novalidate: ""
      }, [
        _createVNode(NologinTitle, {
          "is-entry": true,
          type: props.type
        }, null, 8, ["type"]),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('body.entry.message.auth1')), 1),
          _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('body.entry.message.auth2')), 1)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createVNode(BasePassword, {
                placeholder: _ctx.$t('body.entry.onetimepass.placeholder'),
                modelValue: _unref(state).password,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(state).password) = $event)),
                autocomplete: "one-time-code",
                "init-focus": true,
                "data-test": "password",
                maxlength: 6,
                onInputPasswordEnter: onclick,
                onInputTextEnter: onclick,
                passwordStatus: !_unref(state).dispPassword
              }, null, 8, ["placeholder", "modelValue", "passwordStatus"])
            ]),
            _createVNode(BaseCheckbox, {
              class: "mxa-nologin-main-checkbox",
              modelValue: _unref(state).dispPassword,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(state).dispPassword) = $event)),
              label: _ctx.$t('body.common.passowrd.disp.onetime'),
              domId: "onetimePassDisp"
            }, null, 8, ["modelValue", "label"])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _createElementVNode("button", _hoisted_10, [
              _createTextVNode(_toDisplayString(_ctx.$t('body.entry.redo.message')) + " ", 1),
              _hoisted_11
            ])
          ])
        ]),
        _createVNode(NormalMessage, { normal: _unref(nomralState) }, null, 8, ["normal"]),
        _createVNode(ErrorMessage, { error: _unref(errorState) }, null, 8, ["error"]),
        _createVNode(BaseButton, {
          loading: _unref(isLoading),
          isDisabled: _unref(isDisabled),
          label: _ctx.$t('body.top.button.next.title'),
          styles: "mxa-nologin-main-button",
          onButtonClick: onclick,
          "data-test": "next_button"
        }, null, 8, ["loading", "isDisabled", "label"])
      ], 32)
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          _hoisted_15,
          _createElementVNode("div", _hoisted_16, [
            _createTextVNode(_toDisplayString(_ctx.$t('body.entry.redo.confirm1')), 1),
            _hoisted_17,
            _createTextVNode(_toDisplayString(_ctx.$t('body.entry.redo.confirm2')), 1)
          ]),
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, [
                  _createVNode(BaseButton, {
                    loading: _unref(state).loadingReissue,
                    isDisabled: _unref(state).loadingReissue,
                    label: _ctx.$t('body.entry.button.reissue.title'),
                    onButtonClick: reissue,
                    "data-test": "reissue_button"
                  }, null, 8, ["loading", "isDisabled", "label"])
                ]),
                _createElementVNode("div", _hoisted_22, [
                  _createVNode(BaseButton, {
                    isDisabled: _unref(state).loadingReissue,
                    label: _ctx.$t('body.entry.button.cancel.title'),
                    closeEvent: true,
                    "data-test": "cancel_button"
                  }, null, 8, ["isDisabled", "label"])
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ], 64))
}
}

})